import React from 'react';
import { Link } from 'react-router-dom';
import './Courses.css';

const Courses = () => {
  return (
    <div className="courses-page">
      <div className="container">
        <div className="courses-header">
          <h1>Kurssit</h1>
          <p className="courses-intro">
            Syvennä tietoa ja omaa käytäntöä kurssimateriaaleilla.
          </p>
        </div>
        <div className="courses-list">
          <Link to="/courses/runes" className="course-card card">
            <h2>Riimukurssi</h2>
            <p>Opettele riimut yksi kerrallaan – peili ja käytännön ohjeet.</p>
            <span className="course-link">Siirry kurssille →</span>
          </Link>
          <Link to="/courses/tarot" className="course-card card">
            <h2>Tarot-kurssi</h2>
            <p>Perustasoinen, syväluotaava polku – rakenne, merkitykset ja oma tulkintatyyli.</p>
            <span className="course-link">Siirry kurssille →</span>
          </Link>
          <Link to="/palmistry-101" className="course-card card">
            <h2>Palmistry 101</h2>
            <p>Calm intro to reading the hand — lines, mounts, and grounded interpretation (EN).</p>
            <span className="course-link">Open course →</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Courses;
